import { render, staticRenderFns } from "./ApuracaoAcaoListaModalGerarNdDetalhes.vue?vue&type=template&id=8b4f76e0&scoped=true"
import script from "./ApuracaoAcaoListaModalGerarNdDetalhes.vue?vue&type=script&lang=js"
export * from "./ApuracaoAcaoListaModalGerarNdDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4f76e0",
  null
  
)

export default component.exports